import release from './release';
import releaseAction from './release-action';

export const controllers = { release, 'release-action': releaseAction };
